import { Site } from 'src/models/Site';
import { swrFetch } from 'src/utils/swrFetch';
import useSWR from 'swr';

export const useSite = (siteId: number) => {
    return useSWR<Site>(siteId ? `/sites/${siteId}` : '', swrFetch, {
        suspense: false,
    });
};
